import { render } from "./blocked-browser.vue?vue&type=template&id=38f43a7b&ts=true"
import script from "./blocked-browser.ts?vue&type=script&lang=ts&external"
export * from "./blocked-browser.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__